export default "__VITE_ASSET__4pcZvR_L__"